import {
  ApplyBulkVariantThresholdDocument,
  SetBulkVariantThresholdDocument,
} from "src/generated-gql/graphql";
import {
  IntCustomFieldConfig,
  SharedModule,
  FormInputComponent,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { take } from "rxjs";
@Component({
  selector: "bulk-threshold",
  standalone: true,
  imports: [SharedModule],
  template: `
    <div class="bulk-threshold__input">
      <label>
        {{ "common.preorder-description" | translate }}
      </label>
      <input type="number" [formControl]="formControl" style="width: 100%;"/>
      <!-- <button
        [disabled]="!saveButtonEnabled"
        class="mt-1 button primary"
        (click)="save()"
      >
        Set Threshold
      </button> -->
    </div>
  `,
  styles: `
      .bulk-threshold__input {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: 100%;
      }

      .bulk-threshold__input label{
          color : #666666
      }
  `,
})
export default class BulkThreshold
  implements FormInputComponent<IntCustomFieldConfig>, OnInit
{
  constructor(
    protected dataService: DataService,
    private activeRoute: ActivatedRoute,
    private noti: NotificationService
  ) {}
  ngOnInit(): void {
    this.preThreshold = this.formControl.value;
    this.formControl.valueChanges.subscribe((v) => {
      // this.formControl.markAsPristine();
      this.saveButtonEnabled = this.preThreshold !== v;
    });
  }
  saveButtonEnabled = false;
  readonly: boolean;
  config: IntCustomFieldConfig;

  @Input()
  formControl: FormControl;
  preThreshold: number;

  save() {
    const pid = this.activeRoute.snapshot.params.id;
    //fetch variants ids
    this.dataService.product
      .getProductVariantsForProduct({ skip: 0 }, pid)
      .single$.subscribe((data) => {
        const variants = data.productVariants.items;
        const payload: {
          id: string;
          useGlobalOutOfStockThreshold: boolean;
          outOfStockThreshold: number;
        }[] = [];
        for (const variant of variants) {
          // Convert to positive for calculation, then back to negative
          const currentThreshold = Math.abs(variant.outOfStockThreshold);
          const previousThreshold = Math.abs(this.preThreshold);
          const newThreshold = Math.abs(this.formControl.value);
          
          const calculatedThreshold = currentThreshold - previousThreshold + newThreshold;
          
          payload.push({
            id: variant.id,
            useGlobalOutOfStockThreshold: false,
            outOfStockThreshold: Math.abs(calculatedThreshold) * -1,
          });
        }
        this.dataService
          .mutate(ApplyBulkVariantThresholdDocument, {
            input: payload,
          })
          .pipe(take(1))
          .subscribe((result) => {
            this.dataService
              .mutate(SetBulkVariantThresholdDocument, {
                id: pid,
                threshold: this.formControl.value,
              })
              .subscribe((res) => {
                this.noti.success("Threshold updated successfully");
                this.preThreshold = this.formControl.value;
                this.formControl.markAsPristine();
              });
          });
      });
  }
}
